// Word bank data for guide pages
// Contains Batak Toba words with their Latin transliteration and Indonesian translation

export interface WordBankItem {
  id: number;
  batak: string;
  latin: string[];
  indonesia: string;
  syllable_mapping: {
    batak_char: string;
    latin: string;
  }[];
}

export const wordBank: WordBankItem[] = [
  {
    id: 1,
    batak: "ᯎᯬᯄ᯲ᯄᯮ",
    latin: ["go", "k", "ku"],
    indonesia: "nama saya",
    syllable_mapping: [
      { batak_char: "ᯎᯬ", latin: "go" },
      { batak_char: "ᯄ᯲", latin: "k" },
      { batak_char: "ᯄᯮ", latin: "ku" },
    ],
  },
  {
    id: 2,
    batak: "ᯀᯮ",
    latin: ["au"],
    indonesia: "saya",
    syllable_mapping: [{ batak_char: "ᯀᯮ", latin: "au" }],
  },
  {
    id: 3,
    batak: "ᯘᯪ",
    latin: ["si"],
    indonesia: "si",
    syllable_mapping: [{ batak_char: "ᯘᯪ", latin: "si" }],
  },
  {
    id: 4,
    batak: "ᯀᯉ᯲ᯑᯪ",
    latin: ["a", "n", "di"],
    indonesia: "Andi",
    syllable_mapping: [
      { batak_char: "ᯀ", latin: "a" },
      { batak_char: "ᯉ᯲", latin: "n" },
      { batak_char: "ᯑᯪ", latin: "di" },
    ],
  },
  {
    id: 5,
    batak: "ᯑᯬ",
    latin: ["do"],
    indonesia: "adalah",
    syllable_mapping: [{ batak_char: "ᯑᯬ", latin: "do" }],
  },
  {
    id: 6,
    batak: "ᯔᯒ᯲ᯖᯬᯉᯮᯉ᯲",
    latin: ["ma", "r", "to", "nu", "n"],
    indonesia: "tinggal",
    syllable_mapping: [
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯒ᯲", latin: "r" },
      { batak_char: "ᯖᯬ", latin: "to" },
      { batak_char: "ᯉᯮ", latin: "nu" },
      { batak_char: "ᯉ᯲", latin: "n" },
    ],
  },
  {
    id: 7,
    batak: "ᯅᯞᯪᯎᯩ",
    latin: ["ba", "li", "ge"],
    indonesia: "Balige",
    syllable_mapping: [
      { batak_char: "ᯅ", latin: "ba" },
      { batak_char: "ᯞᯪ", latin: "li" },
      { batak_char: "ᯎᯩ", latin: "ge" },
    ],
  },
  {
    id: 8,
    batak: "ᯇᯩᯄᯩᯒ᯲ᯐᯄᯮ",
    latin: ["pe", "ke", "r", "ja", "ku"],
    indonesia: "pekerjaanku",
    syllable_mapping: [
      { batak_char: "ᯇᯩ", latin: "pe" },
      { batak_char: "ᯄᯩ", latin: "ke" },
      { batak_char: "ᯒ᯲", latin: "r" },
      { batak_char: "ᯐ", latin: "ja" },
      { batak_char: "ᯄᯮ", latin: "ku" },
    ],
  },
  {
    id: 9,
    batak: "ᯎᯮᯒᯮ",
    latin: ["gu", "ru"],
    indonesia: "guru",
    syllable_mapping: [
      { batak_char: "ᯎᯮ", latin: "gu" },
      { batak_char: "ᯒᯮ", latin: "ru" },
    ],
  },
  {
    id: 10,
    batak: "ᯤᯀ",
    latin: ["i", "a"],
    indonesia: "dia",
    syllable_mapping: [
      { batak_char: "ᯤ", latin: "i" },
      { batak_char: "ᯀ", latin: "a" },
    ],
  },
  {
    id: 11,
    batak: "ᯀᯔᯰ",
    latin: ["a", "mang"],
    indonesia: "ayah",
    syllable_mapping: [
      { batak_char: "ᯀ", latin: "a" },
      { batak_char: "ᯔᯰ", latin: "mang" },
    ],
  },
  {
    id: 12,
    batak: "ᯀᯪᯉᯰ",
    latin: ["i", "nang"],
    indonesia: "ibu",
    syllable_mapping: [
      { batak_char: "ᯀᯪ", latin: "i" },
      { batak_char: "ᯉᯰ", latin: "nang" },
    ],
  },
  {
    id: 13,
    batak: "ᯉᯔᯰᯤᯑᯬ",
    latin: ["na", "mang", "i", "do"],
    indonesia: "memanggil",
    syllable_mapping: [
      { batak_char: "ᯉ", latin: "na" },
      { batak_char: "ᯔᯰ", latin: "mang" },
      { batak_char: "ᯤ", latin: "i" },
      { batak_char: "ᯑᯬ", latin: "do" },
    ],
  },
  {
    id: 14,
    batak: "ᯔᯒ᯲ᯘᯪᯖᯮᯖᯮᯒ᯲",
    latin: ["ma", "r", "si", "tu", "tu", "r"],
    indonesia: "berbicara dengan",
    syllable_mapping: [
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯒ᯲", latin: "r" },
      { batak_char: "ᯘᯪ", latin: "si" },
      { batak_char: "ᯖᯮ", latin: "tu" },
      { batak_char: "ᯖᯮ", latin: "tu" },
      { batak_char: "ᯒ᯲", latin: "r" },
    ],
  },
  {
    id: 15,
    batak: "ᯀᯬᯇᯮᯰ ᯑᯬᯞᯪ",
    latin: ["o", "pung", "do", "li"],
    indonesia: "kakek",
    syllable_mapping: [
      { batak_char: "ᯀᯬ", latin: "o" },
      { batak_char: "ᯇᯮᯰ", latin: "pung" },
      { batak_char: "ᯑᯬ", latin: "do" },
      { batak_char: "ᯞᯪ", latin: "li" },
    ],
  },
  //   {
  //     id: 16,
  //     batak: "ᯉᯀ",
  //     latin: ["na"],
  //     indonesia: "yang",
  //     syllable_mapping: [{ batak_char: "ᯉᯀ", latin: "na" }],
  //   },
  {
    id: 17,
    batak: "ᯞᯔ᯲ᯅᯬᯄ᯲",
    latin: ["la", "m", "bo", "k"],
    indonesia: "kuat",
    syllable_mapping: [
      { batak_char: "ᯞ", latin: "la" },
      { batak_char: "ᯔ᯲", latin: "m" },
      { batak_char: "ᯅᯬ", latin: "bo" },
      { batak_char: "ᯄ᯲", latin: "k" },
    ],
  },
  {
    id: 18,
    batak: "ᯇᯒᯮᯔᯀᯩᯉ᯲ ᯅᯬᯒᯮ",
    latin: ["pa", "ru", "ma", "e", "n", "bo", "ru"],
    indonesia: "menantu perempuan",
    syllable_mapping: [
      { batak_char: "ᯇ", latin: "pa" },
      { batak_char: "ᯒᯮ", latin: "ru" },
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯀᯩ", latin: "e" },
      { batak_char: "ᯉ᯲", latin: "n" },
      { batak_char: "ᯅᯬ", latin: "bo" },
      { batak_char: "ᯒᯮ", latin: "ru" },
    ],
  },
  {
    id: 19,
    batak: "ᯄᯮ",
    latin: ["ku"],
    indonesia: "saya",
    syllable_mapping: [{ batak_char: "ᯄᯮ", latin: "ku" }],
  },
  //   {
  //     id: 20,
  //     batak: "ᯖᯬᯞᯔ",
  //     latin: ["jolma"],
  //     indonesia: "orang",
  //     syllable_mapping: [
  //       { batak_char: "ᯖᯬ", latin: "jol" },
  //       { batak_char: "ᯞᯔ", latin: "ma" },
  //     ],
  //   },
  {
    id: 21,
    batak: "ᯅᯤᯄ᯲ᯄᯬᯉ᯲",
    latin: ["ba", "i", "k", "ko", "n"],
    indonesia: "baik",
    syllable_mapping: [
      { batak_char: "ᯅ", latin: "ba" },
      { batak_char: "ᯤ", latin: "i" },
      { batak_char: "ᯄ᯲", latin: "k" },
      { batak_char: "ᯄᯬ", latin: "ko" },
      { batak_char: "ᯉ᯲", latin: "n" },
    ],
  },
  {
    id: 22,
    batak: "ᯔᯒ᯲ᯎ",
    latin: ["ma", "r", "ga"],
    indonesia: "marga",
    syllable_mapping: [
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯒ᯲", latin: "r" },
      { batak_char: "ᯎ", latin: "ga" },
    ],
  },
  {
    id: 23,
    batak: "ᯘᯪᯀᯎᯪᯀᯉ᯲",
    latin: ["si", "a", "gi", "a", "n"],
    indonesia: "Siagian",
    syllable_mapping: [
      { batak_char: "ᯘᯪ", latin: "si" },
      { batak_char: "ᯀ", latin: "a" },
      { batak_char: "ᯎᯪ", latin: "gi" },
      { batak_char: "ᯀ", latin: "a" },
      { batak_char: "ᯉ᯲", latin: "n" },
    ],
  },
  {
    id: 24,
    batak: "ᯂᯔᯪ",
    latin: ["hami"],
    indonesia: "kami",
    syllable_mapping: [
      { batak_char: "ᯂ", latin: "ha" },
      { batak_char: "ᯔᯪ", latin: "mi" },
    ],
  },
  {
    id: 25,
    batak: "ᯇᯪᯒᯬ",
    latin: ["piro"],
    indonesia: "berapa",
    syllable_mapping: [
      { batak_char: "ᯇᯪ", latin: "pi" },
      { batak_char: "ᯒᯬ", latin: "ro" },
    ],
  },
  {
    id: 26,
    batak: "ᯖᯮᯀᯔᯮ",
    latin: ["tu", "a", "mu"],
    indonesia: "umurmu",
    syllable_mapping: [
      { batak_char: "ᯖᯮ", latin: "tu" },
      { batak_char: "ᯀ", latin: "a" },
      { batak_char: "ᯔᯮ", latin: "mu" },
    ],
  },
  {
    id: 27,
    batak: "ᯖᯮᯀᯃᯮ",
    latin: ["tuaku"],
    indonesia: "umurku",
    syllable_mapping: [
      { batak_char: "ᯖᯮ", latin: "tu" },
      { batak_char: "ᯀ", latin: "a" },
      { batak_char: "ᯃᯮ", latin: "ku" },
    ],
  },
  //   {
  //     id: 28,
  //     batak: "ᯖᯬᯞᯮ",
  //     latin: ["tolu"],
  //     indonesia: "tiga",
  //     syllable_mapping: [
  //       { batak_char: "ᯖᯬ", latin: "to" },
  //       { batak_char: "ᯞᯮ", latin: "lu" },
  //     ],
  //   },
  {
    id: 29,
    batak: "ᯖᯀᯬᯉ᯲",
    latin: ["ta", "o", "n"],
    indonesia: "tahun",
    syllable_mapping: [
      { batak_char: "ᯖ", latin: "ta" },
      { batak_char: "ᯀᯬ", latin: "o" },
      { batak_char: "ᯉ᯲", latin: "n" },
    ],
  },
  {
    id: 30,
    batak: "ᯇᯒ᯲ᯎᯮᯒᯬᯉ᯲",
    latin: ["pa", "r", "gu", "ro", "n"],
    indonesia: "pelajar",
    syllable_mapping: [
      { batak_char: "ᯇ", latin: "pa" },
      { batak_char: "ᯒ᯲", latin: "r" },
      { batak_char: "ᯎᯮ", latin: "gu" },
      { batak_char: "ᯒᯬ", latin: "ro" },
      { batak_char: "ᯉ᯲", latin: "n" },
    ],
  },
  {
    id: 31,
    batak: "ᯀᯂ",
    latin: ["aha"],
    indonesia: "apa",
    syllable_mapping: [
      { batak_char: "ᯀ", latin: "a" },
      { batak_char: "ᯂ", latin: "ha" },
    ],
  },
  {
    id: 32,
    batak: "ᯇᯝᯞᯮᯘ᯲ᯔᯮ",
    latin: ["pa", "nga", "lu", "s", "mu"],
    indonesia: "pekerjaanmu",
    syllable_mapping: [
      { batak_char: "ᯇ", latin: "pa" },
      { batak_char: "ᯝ", latin: "nga" },
      { batak_char: "ᯞᯮ", latin: "lu" },
      { batak_char: "ᯘ᯲", latin: "s" },
      { batak_char: "ᯔᯮ", latin: "mu" },
    ],
  },
  {
    id: 33,
    batak: "ᯔᯝᯞᯮᯘᯪ",
    latin: ["ma", "nga", "lu", "si"],
    indonesia: "bekerja",
    syllable_mapping: [
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯝ", latin: "nga" },
      { batak_char: "ᯞᯮ", latin: "lu" },
      { batak_char: "ᯘᯪ", latin: "si" },
    ],
  },
  {
    id: 34,
    batak: "ᯀᯔᯂᯮ",
    latin: ["a", "ma", "hu"],
    indonesia: "ayahku",
    syllable_mapping: [
      { batak_char: "ᯀ", latin: "a" },
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯂᯮ", latin: "hu" },
    ],
  },
  {
    id: 35,
    batak: "ᯇᯒᯮᯔ",
    latin: ["pa", "ru", "ma"],
    indonesia: "petani",
    syllable_mapping: [
      { batak_char: "ᯇ", latin: "pa" },
      { batak_char: "ᯒᯮ", latin: "ru" },
      { batak_char: "ᯔ", latin: "ma" },
    ],
  },
  {
    id: 36,
    batak: "ᯀᯪᯉᯰᯄᯮ",
    latin: ["i", "nang", "ku"],
    indonesia: "ibuku",
    syllable_mapping: [
      { batak_char: "ᯀᯪ", latin: "i" },
      { batak_char: "ᯉᯰ", latin: "nang" },
      { batak_char: "ᯄᯮ", latin: "ku" },
    ],
  },
  {
    id: 37,
    batak: "ᯀᯰᯎᯪᯄᯮ",
    latin: ["ang", "gi", "ku"],
    indonesia: "saudaraku",
    syllable_mapping: [
      { batak_char: "ᯀᯰ", latin: "ang" },
      { batak_char: "ᯎᯪ", latin: "gi" },
      { batak_char: "ᯄᯮ", latin: "ku" },
    ],
  },
  //   {
  //     id: 38,
  //     batak: "ᯑᯬᯖ᯲ᯖᯒ᯲",
  //     latin: ["dottor"],
  //     indonesia: "dokter",
  //     syllable_mapping: [
  //       { batak_char: "ᯑᯬ", latin: "do" },
  //       { batak_char: "ᯖ᯲ᯖᯒ᯲", latin: "ttor" },
  //     ],
  //   },
  //   {
  //     id: 39,
  //     batak: "ᯀᯉ᯲ᯃᯉ᯲ᯃᯮ",
  //     latin: ["angkangku"],
  //     indonesia: "kakakku",
  //     syllable_mapping: [
  //       { batak_char: "ᯀᯉ᯲", latin: "ang" },
  //       { batak_char: "ᯃᯉ᯲", latin: "kang" },
  //       { batak_char: "ᯃᯮ", latin: "ku" },
  //     ],
  //   },
  {
    id: 40,
    batak: "ᯅᯎᯘ᯲",
    latin: ["ba", "ga", "s"],
    indonesia: "rumah",
    syllable_mapping: [
      { batak_char: "ᯅᯎ", latin: "ba" },
      { batak_char: "ᯎ", latin: "ga" },
      { batak_char: "ᯘ᯲", latin: "s" },
    ],
  },
  //   {
  //     id: 41,
  //     batak: "ᯖᯉᯬ ᯔᯒ᯲ᯖᯬᯞᯉ",
  //     latin: ["tano martongan"],
  //     indonesia: "tempat tinggal",
  //     syllable_mapping: [
  //       { batak_char: "ᯖᯉᯬ", latin: "ta" },
  //       { batak_char: "ᯔᯒ᯲", latin: "no" },
  //       { batak_char: "ᯖᯬ", latin: "mar" },
  //       { batak_char: "ᯞᯉ", latin: "tong" },
  //       { batak_char: "ᯉ", latin: "an" },
  //     ],
  //   },
  {
    id: 42,
    batak: "ᯔᯒ᯲ᯖᯬᯰᯎᯬ",
    latin: ["ma", "r", "tong", "go"],
    indonesia: "tinggal",
    syllable_mapping: [
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯒ᯲", latin: "r" },
      { batak_char: "ᯖᯬᯰ", latin: "tong" },
      { batak_char: "ᯎᯬ", latin: "go" },
    ],
  },
  //   {
  //     id: 43,
  //     batak: "ᯑᯤ ᯑᯤᯀ",
  //     latin: ["di dia"],
  //     indonesia: "di mana",
  //     syllable_mapping: [
  //       { batak_char: "ᯑᯤ", latin: "di" },
  //       { batak_char: "ᯑᯤᯀ", latin: "dia" },
  //     ],
  //   },
  {
    id: 44,
    batak: "ᯑᯪ",
    latin: ["di"],
    indonesia: "di",
    syllable_mapping: [{ batak_char: "ᯑᯪ", latin: "di" }],
  },
  {
    id: 45,
    batak: "ᯄᯬᯖ",
    latin: ["kota"],
    indonesia: "kota",
    syllable_mapping: [
      { batak_char: "ᯄᯬ", latin: "ko" },
      { batak_char: "ᯖ", latin: "ta" },
    ],
  },
  {
    id: 46,
    batak: "ᯂᯮᯖ",
    latin: ["huta"],
    indonesia: "desa",
    syllable_mapping: [
      { batak_char: "ᯂᯮ", latin: "hu" },
      { batak_char: "ᯖ", latin: "ta" },
    ],
  },
  {
    id: 47,
    batak: "ᯞᯮᯔ᯲ᯅᯉ᯲",
    latin: ["lumban"],
    indonesia: "kampung",
    syllable_mapping: [
      { batak_char: "ᯞᯮ", latin: "lu" },
      { batak_char: "ᯔ᯲", latin: "m" },
      { batak_char: "ᯅ", latin: "ba" },
      { batak_char: "ᯉ᯲", latin: "n" },
    ],
  },
  // //   {
  // //     id: 48,
  // //     batak: "ᯉᯒᯎᯒᯤ",
  // //     latin: ["negari"],
  // //     indonesia: "negara",
  // //     syllable_mapping: [
  // //       { batak_char: "ᯉᯒ", latin: "ne" },
  // //       { batak_char: "ᯎᯒᯤ", latin: "gari" },
  // //     ],
  // //   },
  //   {
  //     id: 49,
  //     batak: "ᯀᯘᯞ",
  //     latin: ["asal"],
  //     indonesia: "asal",
  //     syllable_mapping: [
  //       { batak_char: "ᯀ", latin: "a" },
  //       { batak_char: "ᯘᯞ", latin: "sal" },
  //     ],
  //   },
  //   {
  //     id: 50,
  //     batak: "ᯑᯂᯞᯉᯤ",
  //     latin: ["dalani"],
  //     indonesia: "jalan",
  //     syllable_mapping: [
  //       { batak_char: "ᯑᯂ", latin: "da" },
  //       { batak_char: "ᯞᯉᯤ", latin: "lani" },
  //     ],
  //   },
  {
    id: 51,
    batak: "ᯇᯐᯄ᯲",
    latin: ["pajak"],
    indonesia: "pasar",
    syllable_mapping: [
      { batak_char: "ᯇ", latin: "pa" },
      { batak_char: "ᯐ", latin: "ja" },
      { batak_char: "ᯄ᯲", latin: "k" },
    ],
  },
  {
    id: 52,
    batak: "ᯇᯒ᯲ᯎᯮᯒᯮᯀᯉ᯲",
    latin: ["parguruan"],
    indonesia: "sekolah",
    syllable_mapping: [
      { batak_char: "ᯇ", latin: "pa" },
      { batak_char: "ᯒ᯲", latin: "r" },
      { batak_char: "ᯎᯮ", latin: "gu" },
      { batak_char: "ᯒᯮ", latin: "ru" },
      { batak_char: "ᯀ", latin: "a" },
      { batak_char: "ᯉ᯲", latin: "n" },
    ],
  },
  {
    id: 53,
    batak: "ᯂᯮᯒᯪᯀ",
    latin: ["huria"],
    indonesia: "gereja",
    syllable_mapping: [
      { batak_char: "ᯂᯮ", latin: "hu" },
      { batak_char: "ᯒᯪ", latin: "ri" },
      { batak_char: "ᯀ", latin: "a" },
    ],
  },
  //   {
  //     id: 54,
  //     batak: "ᯇᯒᯞᯅᯤᯀᯉ",
  //     latin: ["parlabian"],
  //     indonesia: "toko",
  //     syllable_mapping: [
  //       { batak_char: "ᯇᯒ", latin: "par" },
  //       { batak_char: "ᯞᯅᯤ", latin: "la" },
  //       { batak_char: "ᯀᯉ", latin: "bian" },
  //     ],
  //   },
  //   {
  //     id: 55,
  //     batak: "ᯖᯬᯜᯀ ᯉ ᯏᯬᯉᯀ",
  //     latin: ["tonga na jonok"],
  //     indonesia: "kanan",
  //     syllable_mapping: [
  //       { batak_char: "ᯖᯬᯜᯀ", latin: "tonga" },
  //       { batak_char: "ᯉ", latin: "na" },
  //       { batak_char: "ᯏᯬᯉᯀ", latin: "jonok" },
  //     ],
  //   },
  //   {
  //     id: 56,
  //     batak: "ᯖᯬᯜᯀ ᯉ ᯖᯬᯞᯀ",
  //     latin: ["tonga na jolo"],
  //     indonesia: "kiri",
  //     syllable_mapping: [
  //       { batak_char: "ᯖᯬᯜᯀ", latin: "tonga" },
  //       { batak_char: "ᯉ", latin: "na" },
  //       { batak_char: "ᯖᯬᯞᯀ", latin: "jolo" },
  //     ],
  //   },
  {
    id: 57,
    batak: "ᯐᯬᯞᯬ",
    latin: ["jolo"],
    indonesia: "depan",
    syllable_mapping: [
      { batak_char: "ᯐᯬ", latin: "jo" },
      { batak_char: "ᯞᯬ", latin: "lo" },
    ],
  },
  //   {
  //     id: 58,
  //     batak: "ᯇᯖᯮ",
  //     latin: ["pudi"],
  //     indonesia: "belakang",
  //     syllable_mapping: [
  //       { batak_char: "ᯇ", latin: "pu" },
  //       { batak_char: "ᯖᯮ", latin: "di" },
  //     ],
  //   },
  {
    id: 59,
    batak: "ᯑᯇᯬᯖ᯲",
    latin: ["dapot"],
    indonesia: "dekat",
    syllable_mapping: [
      { batak_char: "ᯑ", latin: "da" },
      { batak_char: "ᯇᯬ", latin: "po" },
      { batak_char: "ᯖ᯲", latin: "t" },
    ],
  },
  {
    id: 60,
    batak: "ᯞᯬᯔ᯲ᯇᯄ᯲",
    latin: ["lompak"],
    indonesia: "jauh",
    syllable_mapping: [
      { batak_char: "ᯞᯬ", latin: "lo" },
      { batak_char: "ᯔ᯲", latin: "m" },
      { batak_char: "ᯇ", latin: "pa" },
      { batak_char: "ᯄ᯲", latin: "k" },
    ],
  },
  {
    id: 61,
    batak: "ᯔᯝᯞᯄ᯲",
    latin: ["mangalak"],
    indonesia: "bangun",
    syllable_mapping: [
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯝ", latin: "nga" },
      { batak_char: "ᯞ", latin: "la" },
      { batak_char: "ᯄ᯲", latin: "k" },
    ],
  },
  {
    id: 62,
    batak: "ᯔᯉᯪᯎᯬᯘ᯲",
    latin: ["manigos"],
    indonesia: "mandi",
    syllable_mapping: [
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯉᯪ", latin: "ni" },
      { batak_char: "ᯎᯬ", latin: "go" },
      { batak_char: "ᯘ᯲", latin: "s" },
    ],
  },
  //   {
  //     id: 63,
  //     batak: "ᯇᯉᯞᯮ",
  //     latin: ["mamangan"],
  //     indonesia: "makan",
  //     syllable_mapping: [{ batak_char: "ᯇᯉᯞᯮ", latin: "mamangan" }],
  //   },
  //   {
  //     id: 64,
  //     batak: "ᯑᯬᯉ᯲ᯐᯂ",
  //     latin: ["manampuna"],
  //     indonesia: "berdoa",
  //     syllable_mapping: [{ batak_char: "ᯑᯬᯉ᯲ᯐᯂ", latin: "manampuna" }],
  //   },
  //   {
  //     id: 65,
  //     batak: "ᯔᯂᯬᯉ᯲ᯞ",
  //     latin: ["manogos"],
  //     indonesia: "siap-siap",
  //     syllable_mapping: [{ batak_char: "ᯔᯂᯬᯉ᯲ᯞ", latin: "manogos" }],
  //   },
  //   {
  //     id: 66,
  //     batak: "ᯔᯉᯞᯮᯘᯤ",
  //     latin: ["mangalusi"],
  //     indonesia: "bekerja",
  //     syllable_mapping: [{ batak_char: "ᯔᯉᯞᯮᯘᯤ", latin: "mangalusi" }],
  //   },
  {
    id: 67,
    batak: "ᯔᯉᯮᯰᯄᯮᯉ᯲",
    latin: ["manungkun"],
    indonesia: "belajar",
    syllable_mapping: [
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯉᯮᯰ", latin: "nung" },
      { batak_char: "ᯄᯮ", latin: "ku" },
      { batak_char: "ᯉ᯲", latin: "n" },
    ],
  },
  //   {
  //     id: 68,
  //     batak: "ᯇᯬᯇ᯲ᯞ᯲",
  //     latin: ["marmaen"],
  //     indonesia: "bermain",
  //     syllable_mapping: [{ batak_char: "ᯇᯬᯇ᯲ᯞ᯲", latin: "marmaen" }],
  //   },
  //   {
  //     id: 69,
  //     batak: "ᯈᯩᯅ ᯐᯂ",
  //     latin: ["mamangan pagi"],
  //     indonesia: "sarapan",
  //     syllable_mapping: [
  //       { batak_char: "ᯈᯩᯅ", latin: "mamangan" },
  //       { batak_char: "ᯐᯂ", latin: "pagi" },
  //     ],
  //   },
  //   {
  //     id: 70,
  //     batak: "ᯈᯩᯅ ᯘᯒ᯲",
  //     latin: ["mamangan siang"],
  //     indonesia: "makan siang",
  //     syllable_mapping: [
  //       { batak_char: "ᯈᯩᯅ", latin: "mamangan" },
  //       { batak_char: "ᯘᯒ᯲", latin: "siang" },
  //     ],
  //   },
  //   {
  //     id: 71,
  //     batak: "ᯈᯩᯅ ᯄᯒ᯲ᯂ",
  //     latin: ["mamangan gabeng"],
  //     indonesia: "makan malam",
  //     syllable_mapping: [
  //       { batak_char: "ᯈᯩᯅ", latin: "mamangan" },
  //       { batak_char: "ᯄᯒ᯲ᯂ", latin: "gabeng" },
  //     ],
  //   },
  {
    id: 72,
    batak: "ᯔᯒ᯲ᯖᯰᯤᯀᯰ",
    latin: ["martangiang"],
    indonesia: "pulang",
    syllable_mapping: [
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯒ᯲", latin: "r" },
      { batak_char: "ᯖᯰ", latin: "tang" },
      { batak_char: "ᯤ", latin: "i" },
      { batak_char: "ᯀᯰ", latin: "ang" },
    ],
  },
  //   {
  //     id: 73,
  //     batak: "ᯔᯂ᯲ᯇᯪᯒᯬᯞ᯲",
  //     latin: ["manortor"],
  //     indonesia: "istirahat",
  //     syllable_mapping: [{ batak_char: "ᯔᯂ᯲ᯇᯪᯒᯬᯞ᯲", latin: "manortor" }],
  //   },
  {
    id: 74,
    batak: "ᯔᯉ᯲ᯑᯬᯄ᯲ TV",
    latin: ["mandok TV"],
    indonesia: "menonton TV",
    syllable_mapping: [
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯉ᯲", latin: "n" },
      { batak_char: "ᯑᯬ", latin: "do" },
      { batak_char: "ᯄ᯲", latin: "k" },
      { batak_char: "TV", latin: "TV" },
    ],
  },
  {
    id: 75,
    batak: "ᯔᯔᯖᯩ",
    latin: ["mamate"],
    indonesia: "tidur",
    syllable_mapping: [
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯔ", latin: "ma" },
      { batak_char: "ᯖᯩ", latin: "te" },
    ],
  },
  {
    id: 76,
    batak: "ᯘᯮᯑᯩ ᯀᯒᯪ",
    latin: ["sude ari"],
    indonesia: "setiap hari",
    syllable_mapping: [
      { batak_char: "ᯘᯮ", latin: "su" },
      { batak_char: "ᯑᯩ", latin: "de" },
      { batak_char: "ᯀ", latin: "a" },
      { batak_char: "ᯒᯪ", latin: "ri" },
    ],
  },
  //   {
  //     id: 77,
  //     batak: "ᯂᯰᯅ᯲ᯂ᯳",
  //     latin: ["parngolu"],
  //     indonesia: "pagi",
  //     syllable_mapping: [{ batak_char: "ᯂᯰᯅ᯲ᯂ᯳", latin: "parngolu" }],
  //   },
  //   {
  //     id: 78,
  //     batak: "ᯇᯉᯞᯮᯞ᯲",
  //     latin: ["senggal"],
  //     indonesia: "siang",
  //     syllable_mapping: [{ batak_char: "ᯇᯉᯞᯮᯞ᯲", latin: "senggal" }],
  //   },
  {
    id: 79,
    batak: "ᯎᯅᯩᯰ",
    latin: ["gabeng"],
    indonesia: "malam",
    syllable_mapping: [
      { batak_char: "ᯎ", latin: "ga" },
      { batak_char: "ᯅᯩᯰ", latin: "beng" },
    ],
  },
  //   {
  //     id: 80,
  //     batak: "ᯖ᯲",
  //     latin: ["sai"],
  //     indonesia: "kemudian/lalu",
  //     syllable_mapping: [{ batak_char: "ᯖ᯲", latin: "sai" }],
  //   },
  {
    id: 81,
    batak: "ᯐᯔ᯲",
    latin: ["jam"],
    indonesia: "jam",
    syllable_mapping: [
      { batak_char: "ᯐ", latin: "ja" },
      { batak_char: "ᯔ᯲", latin: "m" },
    ],
  },
  {
    id: 82,
    batak: "ᯀᯬᯉᯬᯔ᯲",
    latin: ["onom"],
    indonesia: "6",
    syllable_mapping: [
      { batak_char: "ᯀᯬ", latin: "o" },
      { batak_char: "ᯉᯬ", latin: "no" },
      { batak_char: "ᯔ᯲", latin: "m" },
    ],
  },
  {
    id: 83,
    batak: "ᯎᯞᯮᯔ᯲ᯅᯰ",
    latin: ["galumbang"],
    indonesia: "sore",
    syllable_mapping: [
      { batak_char: "ᯎ", latin: "ga" },
      { batak_char: "ᯞᯮ", latin: "lu" },
      { batak_char: "ᯔ᯲", latin: "m" },
      { batak_char: "ᯅᯰ", latin: "bang" },
    ],
  },
  {
    id: 84,
    batak: "ᯑᯒᯪ",
    latin: ["dari"],
    indonesia: "dari",
    syllable_mapping: [
      { batak_char: "ᯑ", latin: "da" },
      { batak_char: "ᯒᯪ", latin: "ri" },
    ],
  },
  //   {
  //     id: 85,
  //     batak: "ᯘᯮᯎ᯲ᯉ",
  //     latin: ["songon"],
  //     indonesia: "lalu/kemudian",
  //     syllable_mapping: [{ batak_char: "ᯘᯮᯎ᯲ᯉ", latin: "songon" }],
  //   },
  {
    id: 86,
    batak: "ᯘᯇᯮᯞᯮᯂ᯲",
    latin: ["sapuluh"],
    indonesia: "10",
    syllable_mapping: [
      { batak_char: "ᯘ", latin: "sa" },
      { batak_char: "ᯇᯮ", latin: "pu" },
      { batak_char: "ᯞᯮ", latin: "lu" },
      { batak_char: "ᯂ᯲", latin: "h" },
    ],
  },
  //   {
  //     id: 87,
  //     batak: "ᯘᯀᯑᯀ",
  //     latin: ["ise"],
  //     indonesia: "siapa",
  //     syllable_mapping: [
  //       { batak_char: "ᯘᯀ", latin: "i" },
  //       { batak_char: "ᯑᯀ", latin: "se" },
  //     ],
  //   },
  //   {
  //     id: 88,
  //     batak: "ᯇᯉᯞᯮᯘᯮ ᯅᯎᯘ",
  //     latin: ["pangalus ni bagas"],
  //     indonesia: "pekerjaan",
  //     syllable_mapping: [
  //       { batak_char: "ᯇᯉᯞᯮᯘᯮ", latin: "pangalus" },
  //       { batak_char: "ᯅᯎᯘ", latin: "bagas" },
  //     ],
  //   },
  //   {
  //     id: 89,
  //     batak: "ᯘᯀᯑᯀ",
  //     latin: ["ise"],
  //     indonesia: "mereka",
  //     syllable_mapping: [
  //       { batak_char: "ᯘᯀ", latin: "i" },
  //       { batak_char: "ᯑᯀ", latin: "se" },
  //     ],
  //   },
  //   {
  //     id: 90,
  //     batak: "ᯘᯀ᯲ᯖ",
  //     latin: ["sada"],
  //     indonesia: "1",
  //     syllable_mapping: [{ batak_char: "ᯘᯀ᯲ᯖ", latin: "sada" }],
  //   },
  //   {
  //     id: 91,
  //     batak: "ᯑᯮᯀ",
  //     latin: ["dua"],
  //     indonesia: "2",
  //     syllable_mapping: [{ batak_char: "ᯑᯮᯀ", latin: "dua" }],
  //   },
  //   {
  //     id: 92,
  //     batak: "ᯖᯬᯞᯮ",
  //     latin: ["tolu"],
  //     indonesia: "3",
  //     syllable_mapping: [
  //       { batak_char: "ᯖᯬ", latin: "to" },
  //       { batak_char: "ᯞᯮ", latin: "lu" },
  //     ],
  //   },
  //   {
  //     id: 93,
  //     batak: "ᯇ᯲ᯇᯒ᯲",
  //     latin: ["opat"],
  //     indonesia: "4",
  //     syllable_mapping: [
  //       { batak_char: "ᯇ᯲", latin: "o" },
  //       { batak_char: "ᯇᯒ᯲", latin: "pat" },
  //     ],
  //   },
  //   {
  //     id: 94,
  //     batak: "ᯞᯔ᯲ᯖ",
  //     latin: ["lima"],
  //     indonesia: "5",
  //     syllable_mapping: [
  //       { batak_char: "ᯞᯔ᯲", latin: "li" },
  //       { batak_char: "ᯖ", latin: "ma" },
  //     ],
  //   },
  //   {
  //     id: 95,
  //     batak: "ᯖᯬ",
  //     latin: ["onom"],
  //     indonesia: "6",
  //     syllable_mapping: [{ batak_char: "ᯖᯬ", latin: "onom" }],
  //   },
  //   {
  //     id: 96,
  //     batak: "ᯇᯒᯮᯉ᯲",
  //     latin: ["pitu"],
  //     indonesia: "7",
  //     syllable_mapping: [{ batak_char: "ᯇᯒᯮᯉ᯲", latin: "pitu" }],
  //   },
  //   {
  //     id: 97,
  //     batak: "ᯋᯮᯞᯮ",
  //     latin: ["walu"],
  //     indonesia: "8",
  //     syllable_mapping: [{ batak_char: "ᯋᯮᯞᯮ", latin: "walu" }],
  //   },
  //   {
  //     id: 98,
  //     batak: "ᯘᯀ᯲ᯉ",
  //     latin: ["sia"],
  //     indonesia: "9",
  //     syllable_mapping: [{ batak_char: "ᯘᯀ᯲ᯉ", latin: "sia" }],
  //   },
  {
    id: 99,
    batak: "ᯑᯬ",
    latin: ["do"],
    indonesia: "",
    syllable_mapping: [{ batak_char: "ᯑᯬ", latin: "do" }],
  },
];
